export default __webpack_public_path__ + "static/media/Group514.128a4653.png";